import React from "react";
import BookingGuestCheckoutForm from "./BookingGuestCheckoutForm";
import BookingSignInForm from "./BookingSignInForm";
import BookingSignUpForm from "./BookingSignUpForm";

export default class BookingCustomerInformation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: null,
      success: null,
      loading: false,
      forgot_password_visible: false,
      resend_confirmation_visible: false,
    };

    this.onBack = this.onBack.bind(this);
    this.onGoogleClick = this.onGoogleClick.bind(this);
    this.onToggleForgotPassword = this.onToggleForgotPassword.bind(this);
    this.onToggleResendConfirmation =
      this.onToggleResendConfirmation.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSignIn = this.onSignIn.bind(this);
    this.onSignUp = this.onSignUp.bind(this);
    this.onCustomerValidate = this.onCustomerValidate.bind(this);
    this.onClickCommunicationTerms = this.onClickCommunicationTerms.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.customerForm !== this.props.customerForm &&
      nextProps.customerForm === null
    ) {
      this.setState({
        forgot_password_visible: false,
        errors: null,
        loading: false,
      });
    }
  }

  componentDidMount() {
    var self = this;

    this.gapiLoadInterval = setInterval(function () {
      if (typeof gapi !== "undefined") {
        // load the gapi once it's available
        self.loadGAPI();
      }
    }, 100);

    $(document.body).on("click", ".link-delegate", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $this = $(this);
      var link_action = $this.data("action");

      if (link_action === "forgot_password") {
        self.setState({ forgot_password_visible: true, errors: null }, () => {
          self.props.onChangeCustomerForm(
            "signIn",
            self.props.customerFormName
          );
        });
      } else if (link_action === "sign_in") {
        self.setState({ forgot_password_visible: false, errors: null }, () => {
          self.props.onChangeCustomerForm(
            "signIn",
            self.props.customerFormName
          );
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.gapiLoadInterval) {
      clearInterval(this.gapiLoadInterval);
    }
  }

  componentDidUpdate() {
    if (
      this.props.guest_information &&
      this.props.guest_information.google_token &&
      !$(".google-login-button").data("bs.popover")
    ) {
      // if signed into google, display popover if not already visible
      this.loginProviderPopovers();
    }
  }

  /**
   * Render functions
   */

  render() {
    if (this.props.guest_information && this.props.guest_information.id) {
      return (
        <div
          className="BookingCustomerInformation text-center"
          style={{ padding: "30px 30px 25px 30px", lineHeight: "25px" }}
        >
          {I18n.t("welcome_guest", {
            guest: `${this.props.guest_information.first_name} ${this.props.guest_information.last_name}`,
          })}
          <br />
          {I18n.t("signed_in_with_email", {
            email: this.props.guest_information.email,
          })}
          <br />
          {this.props.sign_out_visible ? (
            <a href="#" className="sign-in" onClick={this.props.onSignOut}>
              <span className="ss-user"></span> {I18n.t("sign_out")}
            </a>
          ) : null}
        </div>
      );
    } else {
      return (
        <div className="BookingCustomerInformation">
          {/* {this.renderLoginProviders()} */}
          {this.renderErrors()}
          {this.renderSuccess()}
          {this.props.customerForm
            ? this.renderCustomerInformationForm()
            : this.renderCustomerInformationSelect()}
          {this.state.loading && (
            <div className="overlay">
              <div className="loader">&nbsp;</div>
            </div>
          )}
        </div>
      );
    }
  }

  renderCheckBox() {
    return (
      <div className="CommunicationTermsAndConditions col-sm-12" ref="TermsAndConditions">
        <label onClick={this.onClickCommunicationTerms}>
          <input
            type="checkbox"
            name="accept_communication_terms"
            value={true}
            checked={this.props.accept_communication_terms}
            onChange={this.props.onChange}
          />{" "}
          <span
            onClick={this.props.onToggleMessageTerms}
            dangerouslySetInnerHTML={{
              __html: I18n.t("i_agree_with_message_terms"),
            }}
          ></span>
        </label>
      </div>
    );
  }

  onClickCommunicationTerms() {
    this.props.onChange({
      target: {
        name: "accept_communication_terms",
        value: !this.props.accept_communication_terms,
      },
    });
  }

  renderBackAndButton() {
    if (this.props.customerForm === null) {
      return null;
    } else {
      return (
        <div className="continue-btn-wrapper">
          {this.renderOtherActions()}
          {this.renderBack()}
          {this.renderButton()}
        </div>
      );
    }
  }

  renderBack() {
    if (this.state.forgot_password_visible) {
      return (
        <a
          href="#"
          className="back-link"
          onClick={() => this.forgotPasswordBack()}
        >
          {I18n.t("back")}
        </a>
      );
    } else if (this.state.resend_confirmation_visible) {
      return (
        <a
          href="#"
          className="back-link"
          onClick={() => this.resendConfirmationBack()}
        >
          {I18n.t("back")}
        </a>
      );
    } else if (this.props.customerForm) {
      return (
        <a href="#" className="back-link" onClick={() => this.onBack()}>
          {I18n.t("back")}
        </a>
      );
    }
  }

  onBack() {
    this.setState({ errors: null, success: null }, () => {
      this.props.onChangeCustomerForm(null, this.props.customerFormName);
    });
  }

  forgotPasswordBack() {
    var signinInfo = {
      target: {
        name: "password",
        value: null,
      },
    };
    this.props.onChangeSignInInformation(signinInfo);
    this.setState({
      forgot_password_visible: false,
      errors: null,
      success: null,
    });
  }

  resendConfirmationBack() {
    this.setState({
      resend_confirmation_visible: false,
      errors: null,
      success: null,
    });
  }

  renderButton() {
    if (this.props.customerForm === "signIn") {
      if (this.state.forgot_password_visible) {
        return (
          <button type="submit" className="btn">
            {I18n.t(this.props.forgotPasswordButtonText || "forgot_password")}
          </button>
        );
      } else if (this.state.resend_confirmation_visible) {
        return (
          <button type="submit" className="btn">
            {I18n.t("resend_confirmation_instructions")}
          </button>
        );
      } else {
        return (
          <button type="submit" className="btn">
            {I18n.t(this.props.signInButtonText || "sign_in")}
          </button>
        );
      }
    } else if (this.props.customerForm === "signUp") {
      return (
        <button type="submit" className="btn">
          {I18n.t(this.props.signUpButtonText || "sign_up")}
        </button>
      );
    } else if (this.props.customerForm === "guest") {
      return (
        <button type="submit" className="btn">
          {I18n.t("continue")}
        </button>
      );
    }
  }

  renderCustomerInformationForm() {
    var hasErrors = this.hasErrors();

    if (this.props.customerForm === "guest") {
      return (
        <form onSubmit={this.onSubmit} style={{ margin: 0 }}>
          <BookingGuestCheckoutForm
            {...this.props}
            {...this.state}
            hasErrors={hasErrors}
          />
          {this.props.property && this.props.property.enable_messaging_terms ? this.renderCheckBox() : null}
          {this.renderBackAndButton()}
        </form>
      );
    } else if (this.props.customerForm === "signIn") {
      return (
        <form onSubmit={this.onSubmit} style={{ margin: 0 }}>
          <BookingSignInForm
            {...this.props}
            {...this.state}
            hasErrors={hasErrors}
          />
          {this.props.property && this.props.property.enable_messaging_terms ? this.renderCheckBox() : null}
          {this.renderBackAndButton()}
        </form>
      );
    } else if (this.props.customerForm === "signUp") {
      return (
        <form onSubmit={this.onSubmit} style={{ margin: 0 }}>
          <BookingSignUpForm
            {...this.props}
            {...this.state}
            hasErrors={hasErrors}
          />
          {this.renderBackAndButton()}
        </form>
      );
    }
  }

  renderCustomerInformationSelect() {
    if (this.props.guestCustomerForm === false) {
      return (
        <div className="CustomerInformationSelect">
          <div className="row select-mode">
            <div className="col-sm-6">
              <div className="content">
                <h3>{I18n.t("returning_customer")}</h3>
                <p>{I18n.t("welcome_back")}</p>
              </div>
              <div className="buttons">
                <button
                  type="button"
                  className="btn btn-block btn-dark"
                  onClick={this.props.onChangeCustomerForm.bind(
                    this,
                    "signIn",
                    this.props.customerFormName
                  )}
                >
                  {I18n.t("sign_in")}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="CustomerInformationSelect">
          <div className="row select-mode">
            <div className="col-sm-6">
              <div className="content">
                <h3>{I18n.t("new_customer")}</h3>
              </div>
              <div className="buttons">
                <button
                  type="button"
                  className="btn btn-block btn-dark"
                  onClick={this.props.onChangeCustomerForm.bind(
                    this,
                    "guest",
                    this.props.customerFormName
                  )}
                >
                  {I18n.t("continue")}
                </button>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="content">
                <h3>{I18n.t("returning_customer")}</h3>
              </div>
              <div className="buttons">
                <button
                  type="button"
                  className="btn btn-block btn-dark"
                  onClick={
                    this.props.onChangeCustomerForm.bind(
                    this,
                    "signIn",
                    this.props.customerFormName
                  )}
                >
                  {I18n.t("sign_in")}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  renderErrors() {
    var self = this;
    if (this.hasErrors()) {
      if (Array.isArray(this.state.errors)) {
        var errors = this.state.errors.map(function (error) {
          return (
            <li
              key={error}
              dangerouslySetInnerHTML={{ __html: self.processError(error) }}
            ></li>
          );
        });
      } else {
        var errors = Object.keys(this.state.errors).map(function (key) {
          if (I18n.lookup(key)) {
            var name = I18n.t(key);
          }
          return (
            <li key={key}>
              {name} {self.state.errors[key][0]}
            </li>
          );
        });
      }
      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderSuccess() {
    if (this.state.success) {
      return (
        <div className="alert alert-success">
          <ul>{this.state.success}</ul>
        </div>
      );
    }
  }

  renderLoginProviders() {
    if (
      (this.props.customerForm === "signIn" ||
        this.props.customerForm === "signUp") &&
      !this.state.forgot_password_visible
    ) {
      return (
        <div>
          <div className="login-provider-button-wrapper">
            <div className="google-login-button-wrapper">
            </div>
          </div>

          <hr />
        </div>
      );
    }
  }

  renderOtherActions() {
    if (
      this.props.customerForm === "signIn" &&
      !this.state.forgot_password_visible &&
      !this.state.resend_confirmation_visible
    ) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            float: "left",
          }}
        >
          <a
            href="#"
            onClick={this.onToggleForgotPassword}
            className="other-link"
          >
            {I18n.t("forgot_password")}
          </a>
        </div>
      );
    }
  }

  /**
   * Change handlers
   */

  onGoogleClick() {
    var self = this;

    if (gapi && gapi.auth2 && gapi.auth2.authorize) {
      gapi.auth2.authorize(
        {
          client_id: self.props.google_id,
          cookie_policy: "single_host_origin",
          scope: "email profile",
          response_type: "code",
        },
        function (response) {
          if (response && !response.error) {
            response.property_id = self.props.property.id;
            jQuery.ajax({
              type: "POST",
              url: "/auth/google_oauth2/callback",
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              },
              data: response,
              success: function (data) {
                if (
                  self.props.customerForm === "signUp" &&
                  data &&
                  data.id &&
                  !data.google_token
                ) {
                  // sign up, but user already has id, which means they already exist, so they should sign in instead
                  // deleting data.id will make this happen
                  data = { id: undefined, email: data.email_address };
                }
                self.props.onGoogleSignIn(data, self.onCustomerValidate);
              },
            });
          } else {
            // google authentication failed
          }
        }
      );
    }
  }

  onToggleForgotPassword() {
    this.setState({
      forgot_password_visible: !this.state.forgot_password_visible,
      errors: null,
      success: null,
    });
  }

  onToggleResendConfirmation() {
    this.setState({
      resend_confirmation_visible: !this.state.resend_confirmation_visible,
      errors: null,
      success: null,
    });
  }

  onForgotPassword() {
    var self = this;

    self.setState({ loading: true });
    $.ajax({
      type: "POST",
      url: this.props.customer_forgot_password_path,
      data: {
        email:
          self.props.sign_in_information.email ||
          self.props.guest_information.email ||
          "",
        api_key: this.props.account.api_key,
        property: this.props.property.id,
      },
    }).done((data) => {
      if (data.missing_email) {
        self.setState({
          loading: false,
          errors: [I18n.t("email_address") + " " + I18n.t("cant_be_blank")],
          success: null,
        });
      } else {
        self.setState({
          loading: false,
          forgot_password_visible: false,
          errors: null,
          success: I18n.t("forgot_password_success"),
        });
      }
    });
  }

  onResendConfirmation() {
    var self = this;
    self.setState({ loading: true });
    $.ajax({
      type: "POST",
      url: this.props.customer_resend_confirmation_path,
      data: {
        email:
          self.props.sign_in_information.email ||
          self.props.guest_information.email ||
          "",
        api_key: this.props.account.api_key,
        property: this.props.property.id,
      },
    }).done((data) => {
      if (data.missing_email) {
        self.setState({
          loading: false,
          errors: [I18n.t("email_address") + " " + I18n.t("cant_be_blank")],
          success: null,
        });
      } else {
        self.setState({
          loading: false,
          resend_confirmation_visible: false,
          errors: null,
          success: I18n.t("check_your_inbox_and_confirm_new_email"),
        });
      }
    });
  }

  onCustomerValidate() {
    var self = this;
    self.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: this.props.customer_validate_path,
      data: {
        ...this.props.guest_information,
        account_id: this.props.account.id,
        property_id: this.props.property_id,
        api_key: this.props.account.api_key,
        rating_answers: this.props.rating_answers || [],
        emoji_answers: this.props.emoji_answers || [],
      },
    }).done((data) => {
      if (data && data.errors) {
        if (self.props.customerForm === "signIn") {
          // if customerValidate called on signIn, that means we need to take user to signUp to correct errors
          self.props.onChangeCustomerForm(
            "signUp",
            self.props.customerFormName,
            function () {
              self.setState({
                loading: false,
                errors: data.errors,
                success: null,
              });
            }
          );
        } else {
          self.setState({ loading: false, errors: data.errors, success: null });
        }
        self.loginProviderPopovers(true);
      } else {
        if (self.props.customerForm === "signIn") {
          // just had a google sign in
          if (typeof self.props.onSignInSuccess === "function") {
            setTimeout(self.props.onSignInSuccess, 1);
            self.props.onChangeGuestSectionValid(true);
          }
        } else if (
          self.props.customerForm === "signUp" &&
          self.props.guest_information &&
          self.props.guest_information.id
        ) {
          // on sign up page...but user did google sign up with a user already in our database...so instead of signUp, we auto signIn the user instead
          if (typeof self.props.onSignInSuccess === "function") {
            setTimeout(self.props.onSignInSuccess, 1);
            self.props.onChangeGuestSectionValid(true);
          }
        } else {
          if (typeof self.props.onGuestSuccess === "function") {
            setTimeout(self.props.onGuestSuccess, 1);
            self.props.onChangeGuestSectionValid(true);
          }
        }
        self.setState({ loading: false, errors: null, success: null });
        self.loginProviderPopovers(false);
      }
    });
  }

  onSignIn() {
    var self = this;

    self.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: this.props.customer_sign_in_path,
      data: {
        email:
          self.props.sign_in_information.email ||
          self.props.guest_information.email ||
          "",
        password: self.props.sign_in_information.password,
        account_id: self.props.account.id,
        api_key: this.props.account.api_key,
      },
    }).done((data) => {
      if (data && data.errors) {
        self.setState({ loading: false, errors: data.errors, success: null });
        self.loginProviderPopovers(true);
        self.props.onChangeGuestSectionValid(false);
      } else {
        // get default card_id
        var card_id = null;
        if (data && data.cards && data.cards.length) {
          for (var i = 0, ilen = data.cards.length; i < ilen; i++) {
            if (data.cards[i].default) {
              card_id = data.cards[i].id;
              break;
            }
          }
        }
        self.props.onSetCardId(card_id);
        self.props.onSetGuestConfirmed(data.guest_confirmed);
        self.props.onSetGuestInformation(data);
        // self.props.onChangePaymentMethod({ target: { name: 'save_card', checked: true }})
        sessionStorage.setItem("card_id", card_id);
        sessionStorage.setItem("guest_information", JSON.stringify(data));
        if (typeof self.props.onSignInSuccess === "function") {
          setTimeout(self.props.onSignInSuccess, 1);
          self.props.onChangeGuestSectionValid(true);
        }
        self.setState({ loading: false, errors: null });
        self.loginProviderPopovers(false);
      }
    });
  }

  onSignUp() {
    var self = this;

    self.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: this.props.customer_sign_up_path,
      data: {
        ...this.props.guest_information,
        account_id: this.props.account.id,
        property_id: this.props.property.id,
        api_key: this.props.account.api_key,
        rating_answers: this.props.rating_answers || [],
        emoji_answers: this.props.emoji_answers || [],
      },
    }).done((data) => {
      if (data && data.errors) {
        self.setState({ loading: false, errors: data.errors, success: null });
        self.loginProviderPopovers(true);
      } else {
        self.props.onSetGuestConfirmed(data.guest_confirmed);
        self.props.onSetGuestInformation(data);
        sessionStorage.setItem("guest_information", JSON.stringify(data));
        if (typeof self.props.onSignUpSuccess === "function") {
          setTimeout(self.props.onSignUpSuccess, 1);
          self.props.onChangeGuestSectionValid(true);
        }
        self.setState({ loading: false, errors: null });
        self.loginProviderPopovers(false);
      }
    });
  }

  onSubmit(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ loading: true });
    if (this.props.customerForm === "signUp") {
      this.onSignUp();
    } else if (this.props.customerForm === "signIn") {
      if (this.state.forgot_password_visible) {
        this.onForgotPassword();
      } else if (this.state.resend_confirmation_visible) {
        this.onResendConfirmation();
      } else {
        this.onSignIn();
      }
    } else if (this.props.customerForm === "guest") {
      this.onCustomerValidate();
    }
  }

  /**
   * Helper functions
   */

  hasErrors() {
    return (
      this.state.errors &&
      ((Array.isArray(this.state.errors) && this.state.errors.length > 0) ||
        Object.keys(this.state.errors).length > 0)
    );
  }

  loadGAPI() {
    var self = this;
    gapi.load("auth2", function () {
      if (self.gapiLoadInterval) {
        clearInterval(self.gapiLoadInterval);
      }
    });
  }

  loginProviderPopovers(errors) {
    var self = this;

    if (
      self.props.guest_information &&
      self.props.guest_information.google_token &&
      this.props.customerForm === "signUp" &&
      this.props.guest_information.id !== undefined
    ) {
      var $googleLoginButton = $(".google-login-button");
      $googleLoginButton
        .popover("dispose")
        .popover({
          content:
            I18n.t("thanks_for_signing_up_with_google") +
            (errors ? "<br />" + I18n.t("we_need_more_information") : ""),
          trigger: "manual",
          html: true,
          placement: "right",
          container: ".google-login-button-wrapper",
        })
        .on("show.bs.popover", function () {
          var pid = $googleLoginButton.attr("aria-describedby");
          $(".popover").not(`[id!="${pid}"]`).remove();
        })
        .popover("show");
    }
  }

  processError(error) {
    error = error.replace(
      /%{forgot_password_link}/gi,
      `<a href="#" class="link-delegate" data-action="forgot_password">${I18n.t(
        "forgot_password"
      ).toLowerCase()}</a>`
    );
    error = error.replace(
      /%{sign_in_link}/gi,
      `<a href="#" class="link-delegate" data-action="sign_in">${I18n.t(
        "sign_in"
      ).toLowerCase()}</a>`
    );
    return error;
  }
}
